import { NodeTaskData } from "components/flow/nodes/mapper";
import { colors } from "../../../../../theme/tokens/variables";
import LinkIcon from "./icons/LinkIcon";

const HTTPPollTask = ({ nodeData }: any) => {
  const mode = "dark";
  const darkMode = mode === "dark";

  const { task } = nodeData;
  const {
    inputParameters: { http_request: request },
  } = task;

  return (
    <div style={{ marginTop: "20px" }}>
      <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
        <div style={{ marginRight: "10px", flexShrink: 0 }}>
          <LinkIcon />
        </div>
        <div
          style={{
            fontSize: "0.8em",
            padding: "4px 8px",
            color: darkMode ? colors.gray14 : colors.gray01,
            background: darkMode ? colors.gray06 : colors.gray12,
            borderRadius: "5px",
            height: "fit-content",
          }}
        >
          {request?.method}
        </div>
        <div
          style={{
            padding: "0 8px",
            lineHeight: "2em",
            overflow: "hidden",
            textOverflow: "ellipsis",
            wordBreak: "keep-all",
            whiteSpace: "nowrap",
          }}
        >
          {request?.method === "GET" ? (
            <a
              href={request?.uri}
              style={{ textDecoration: "none", color: "inherit" }}
              target="_blank"
              rel="noreferrer"
            >
              {request?.uri}
            </a>
          ) : (
            request?.uri
          )}
        </div>
      </div>
    </div>
  );
};

export default HTTPPollTask;
